declare global {
  interface Window {
    dataLayer: any[];
  }
}

export const initGTM = (): void => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "consent_update",
    consentGranted: true,
  });
};